export class PasswordChangeForm {
    constructor(
        public oldPassword: string,
        public newPassword: string,

    ) { }

    static adapt(item: any): PasswordChangeForm {
        return new PasswordChangeForm(
            item.oldPassword,
            item.newPassword,
        );
    }
}
